import * as React from "react"

const style ={
    backgroundColor: '#af9b9a',
    color: '#eeeeee',
    borderTop: '1px solid #dedede'
}

const seoLinks = [
    {
        title: "Crop Video for Instagram Story size",
        url: "/apps/magicrop/crop-video-free-instagram-story"
    },
    {
        title: "Crop Video Free No Watermark",
        url: "/apps/magicrop/crop-video-free-no-watermark"
    },
    {
        title: "Video cropper app for Facebook videos",
        url: "/apps/magicrop/free-facebook-video-cropper-resize"
    },
    {
        title: "Video cropper app for Instagram videos",
        url: "/apps/magicrop/free-instagram-video-cropper-resize"
    },
    {
        title: "Video cropper app for Tiktok videos",
        url: "/apps/magicrop/free-tiktok-video-cropper-resize"
    },    {
        title: "How to crop video format on iPad",
        url: "/apps/magicrop/how-to-crop-video-format-keep-subject-center-ipad-app"
    },    {
        title: "How to crop video to the right size",
        url: "/apps/magicrop/resize-crop-video-to-the-right-aspect-ratio"
    },
    {
        title: "Video Crop editor alternative to Adobe Premier Pro",
        url: "/apps/magicrop/crop-video-adobe-premiere"
    },
    {
        title: "Video Crop editor alternative to Apple Final Cut Pro",
        url: "/apps/magicrop/crop-video-apple-final-cut"
    }
]

function MCSEOFooter(props) {

    return (<div style={style} 
                    className="flex flex-row place-content-center items-center text-base p-10">
                    
                    <div className='flex flex-col'>
                        <div className="font-bold">CREATE</div>
                        {
                            seoLinks.map(item => <div><a href={item.url}>{item.title}</a></div>)
                        }
                    </div>
                    <div className='flex-auto flex place-content-center items-center'>
                        
                    </div>
            </div>)
}

export default MCSEOFooter